import React, { useContext } from 'react'
import { CategoryItem, SearchResultsProps } from './types'
import styles from './PullDown.module.css'
import { StepContext } from '../../Steps/StepContainer'
import { FormValues, UserResume } from '../../Store/reducers/formReducer/types'

export const SearchResults = ({
    results,
    formKey,
    displayFormKey,
    idField,
    clickLabelPrefix = '',
    formatClickLabel = label => label,
    onSelect,
}: SearchResultsProps) => {
    const {
        handleNext,
        setFormValue,
        updateUserResume,
        setDisplayValue,
        formState,
    } = useContext(StepContext)

    const selectedId = formState.userResumesAttributes[0][idField]

    if (!results.length) {
        return <p>一致する結果が見つかりませんでした</p>
    }

    const handleItemClick = (item: CategoryItem) => {
        onSelect?.()
        setDisplayValue(displayFormKey, item.name)

        if (Array.isArray(formKey) && formKey[0] === 'userResumesAttributes') {
            updateUserResume(0, formKey[1] as keyof UserResume, item.id)
        } else {
            setFormValue(formKey as keyof FormValues, item.id)
        }

        handleNext()
    }

    return (
        <>
            {results.map(({ item, category }, index) => (
                <div key={index}>
                    <button
                        className={`${styles.searchResult} ${
                            selectedId === item.id ? styles.selected : ''
                        }`}
                        onClick={() => handleItemClick(item)}
                        data-click-label={formatClickLabel(
                            `${clickLabelPrefix}_${item.name}`
                        )}
                    >
                        <div className={styles.searchResultCategory}>
                            <p>{category}</p>
                        </div>
                        <div className={styles.searchResultItem}>
                            <p>{item.name}</p>
                            <span>›</span>
                        </div>
                    </button>
                </div>
            ))}
        </>
    )
}
